export const diplomes = [
    {
        startDate: "2009",
        endDate: "2012",
        title: "Thèse",
        speciality: "Informatique",
        school: "Université Montpellier 2, IBM",
        city: "Montpellier",
        country: "France",
        description: ""
    },
    {
        startDate: "2007",
        endDate: "2009",
        title: "Master",
        speciality: "Informatique",
        school: "Université Montpellier 2",
        city: "Montpellier",
        country: "France",
        description: "Web, IA"
    },
    {
        startDate: "2006",
        endDate: "2007",
        title: "Licence",
        speciality: "Informatique",
        school: "Université Montpellier 2",
        city: "Montpellier",
        country: "France",
        description: ""
    },
    {
        startDate: "2004",
        endDate: "2006",
        title: "BTS ",
        speciality: "Informatique de Gestion",
        school: "Lycée Jean Mermoz",
        city: "Montpellier",
        country: "France",
        description: ""
    }, {
        startDate: "2003",
        endDate: "2003",
        title: "Baccalauréat",
        speciality: "Électronique",
        school: "Lycée Emile Peytavin",
        city: "Mende",
        country: "France",
        description: ""
    },

]
export const job = [
    {
        startDate: "2023",
        endDate: "2026",
        title: "Ingénieur R&D",
        speciality: "Full Stack",
        school: "INRIA",
        city: "Montpellier",
        country: "France",
        description: "Java, MongoDB, PostgreSQL, React, Architecture, Microservices"
    },
    {
        startDate: "2019",
        endDate: "2019",
        title: "Ingénieur R&D",
        speciality: "Full Stack, DevOps",
        school: "Klanik (Brli)",
        city: "Nîmes",
        country: "France",
        description: "Play Framework, Java, React JS, MongoDB, Kubernetes, Architecture IOT, Microservices, application mobile"
    },
    {
        startDate: "2015",
        endDate: "2019",
        title: "Ingénieur R&D",
        speciality: "Full Stack, DevOps, support",
        school: "ITK, Medria",
        city: "Montpellier, Rennes",
        country: "France",
        description: "PHP, IOT, LoRaWAN, Cat-M, C++, JAVA, Angular JS, InfluxDB, Grafana, MQTT, CIR, Architecture Big Data, OpenShift, Kubernetes, Microservices"
    },
    {
        startDate: "2014",
        endDate: "2015",
        title: "Ingénieur R&D",
        speciality: "Full Stack, DevOps",
        school: "INRIA",
        city: "Grenoble",
        country: "France",
        description: "Hadoop, NoSQL, Yarn, Lambda Architecture, JAVA, C++"
    },
    {
        startDate: "2012",
        endDate: "2013",
        title: "PDG",
        speciality: "Full Stack, DevOps",
        school: "LIP6, Université Pierre et Marie Curie",
        city: "PARIS",
        country: "France",
        description: "TBB, OpenMP, SIMD, ISPC, XeonPHI, Bash, Perl, C++"
    }
]
export const teaching = [
    {
        startDate: "2026",
        endDate: "présent",
        title: "Maître de conférences",
        speciality: "",
        school: "Polytech Montpellier",
        city: "Montpellier",
        country: "France",
        description: "IA, DevOps, Architecture Logicielle, création d'entreprise."
    },
    {
        startDate: "2023",
        endDate: "2026",
        title: "Chargé de Cours",
        speciality: "",
        school: "Polytech Montpellier",
        city: "Montpellier",
        country: "France",
        description: "IA, DevOps, Architecture Logicielle, création d'entreprise."
    },
    {
        startDate: "2020",
        endDate: "2022",
        title: "Chargé de Cours",
        speciality: "",
        school: "IUT de Montpellier",
        city: "Montpellier",
        country: "France",
        description: "Définition du PPE. Bases de l'informatique. Initiation et techniques avancées pour Word, Excel et PowerPoint. Montage vidéo et création graphique."
    },
    {
        startDate: "2013",
        endDate: "2014",
        title: "Chargé de Cours et TP",
        speciality: "EMACS",
        school: "École des Mines d'Alès",
        city: "Nîmes",
        country: "France",
        description: "Création, utilisation de moteurs de jeux. Développement de jeux vidéo. Mise en place de réalité virtuelle."
    },
    {
        startDate: "2013",
        endDate: "2014",
        title: "Responsable, chargé de Cours et TP",
        speciality: "IMAGINA",
        school: "Université Montpellier 2",
        city: "Montpellier",
        country: "France",
        description: "Création, utilisation de moteurs de jeux. Développement de jeux vidéo. Calcul parallèle CPU et GPU."
    },
    {
        startDate: "2012",
        endDate: "2013",
        title: "Chargé de TP",
        speciality: "",
        school: "Polytech UPMC",
        city: "Paris",
        country: "France",
        description: "Programmation parallèle"
    },
    {
        startDate: "2010",
        endDate: "2012",
        title: "Moniteur",
        speciality: "",
        school: "IUT Béziers",
        city: "Béziers",
        country: "France",
        description: "Apprentissage de l'utilisation de l'outil Unity3D. Initiation Java, Informatique graphique & représentation de l'information"
    },
    {
        startDate: "2007",
        endDate: "2008",
        title: "Professeur particulier",
        speciality: "",
        school: "Acadomia",
        city: "Montpellier",
        country: "France",
        description: "Mathématiques, Physique & Électronique"
    }
]
export const pdg = [
    {
        startDate: "2021",
        endDate: "2023",
        title: "PDG",
        speciality: "Full Stack, DevOps, IA",
        school: "ANIWEE",
        city: "Montpellier",
        country: "France",
        description: "Java, React JS, MongoDB, Kubernetes, Architecture IOT, Microservices, application mobile"
    },
    {
        startDate: "2020",
        endDate: "2022",
        title: "PDG",
        speciality: "Full Stack, DevOps, IA",
        school: "DATA TAEERAE",
        city: "Montpellier",
        country: "France",
        description: "Java, React JS, MongoDB, Kubernetes, Architecture IOT, Microservices, application mobile, PHP"
    },
    {
        startDate: "2013",
        endDate: "2023",
        title: "PDG",
        speciality: "Full Stack, DevOps, IoT",
        school: "Qubby",
        city: "Paris",
        country: "France",
        description: "ATMEL, ARM, X86, Wifi, Bluetooth, C++"
    }, {
        startDate: "2011",
        endDate: "2024",
        title: "Conseils",
        speciality: "R&D",
        school: "NaturalPad",
        city: "Montpellier",
        country: "France",
        description: "Quantified self, Santé, traitement du signal, Unity, OpenCV, C#, C++"
    }, {
        startDate: "2008",
        endDate: "2008",
        title: "PDG",
        speciality: "Full Stack",
        school: "L-Multimédia",
        city: "Montpellier",
        country: "France",
        description: "Joomla, PHP, MySQL"
    },

]